import React, { useEffect, useState, useRef } from "react";
import { Button, Box, Typography, TextField, Link, Grid } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import GetAppIcon from "@mui/icons-material/GetApp";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import Subheader from "../../../Componants/Common/Subheader";
import InputFileUpload from "../../../Componants/Common/Bulk Upload/InputFileUpload";
import CommonButton from "../../../Componants/Common/Button";
import Template from "../../../Componants/Common/Bulk Upload/Template";
import toast, { Toaster } from "react-hot-toast";
import {
  downloadGeographyReference,
  downloadGeographyTemplate,
  uploadGeography,
} from "../../../API Service/apiService";
import FileSaver from "file-saver";
import Loader from "../../../Componants/Loader/Loader";

const BulkUploadLocality = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef(null);

  const validateFile = (file) => {
    if (!file) {
      toast.error("Please select a file");
      return false;
    }

    // Check file type
    const allowedTypes = [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "application/vnd.ms-excel", // .xls
      "text/csv", // .csv
    ];

    if (!allowedTypes.includes(file.type)) {
      toast.error("Please upload only Excel or CSV files");
      return false;
    }

    // Check file size (e.g., max 5MB)
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    if (file.size > maxSize) {
      toast.error("File size should be less than 5MB");
      return false;
    }

    return true;
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && validateFile(file)) {
      setSelectedFile(file);
      toast.success("File selected successfully");
    } else {
      // Reset file input
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setSelectedFile(null);
    }
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      toast.error("Please select a file first");
      return;
    }

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);
      // Call uploadGeography with the selected file
      const response = await uploadGeography(formData);
      if (response.status === 299) {
        const failedRowsLink = response.data.failedRowsLink;
        toast(
          (t) => (
            <div
              style={{ display: "flex", alignItems: "center", padding: "10px" }}
            >
              <span
                style={{
                  color: "yellow",
                  fontSize: "1.5rem",
                  marginRight: "12px",
                }}
              >
                ⚠️
              </span>
              <div style={{ flex: 1 }}>
                <strong>Import completed with some errors.</strong>
                <div style={{ marginTop: "5px" }}>
                  <div>Valid Count: {response.data.validCount}</div>
                  <div>Invalid Count: {response.data.invalidCount}</div>
                  <div>Duplicate Count: {response.data.duplicateCount}</div>
                  <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => window.open(failedRowsLink, "_blank")}
                    style={{ marginTop: "8px" }}
                  >
                    Download Failed Rows
                  </Button>
                </div>
              </div>
              <span
                style={{
                  marginLeft: "auto",
                  cursor: "pointer",
                  color: "red",
                  fontWeight: "bold",
                  fontSize: "1.5rem",
                }}
                onClick={() => toast.dismiss(t.id)}
              >
                &times;
              </span>
            </div>
          ),
          { duration: Infinity }
        );
      } else {
        toast.success("File uploaded successfully");
      }
      // if (response && response.status === "success") {
      //   toast.success("File uploaded successfully");
      //   // Reset the file input after successful upload
      //   if (fileInputRef.current) {
      //     fileInputRef.current.value = "";
      //   }
      //   setSelectedFile(null);
      // } else {
      //   toast.error(response?.message || "Error in uploading file");
      // }
    } catch (error) {
      console.error("Error in uploading file:", error);
      // Better error handling to show specific messages from API
      toast.error(error?.response?.data?.message || "Error in uploading file");
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadReference = async () => {
    try {
      console.log("Downloading file...");
      const response = await downloadGeographyReference();

      // Create a Blob from the response data
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, "city.xlsx");

      toast.success("Reference code downloaded successfully");
    } catch (error) {
      console.error("Error in downloading file:", error);
      toast.error("Error in downloading file");
    }
  };
  const handleDownloadTemplate = async () => {
    try {
      console.log("Downloading file...");
      const response = await downloadGeographyTemplate();

      // Create a Blob from the response data
      const blob = new Blob([response], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, "geography_template");

      toast.success("Reference code downloaded successfully");
    } catch (error) {
      console.error("Error in downloading file:", error);
      toast.error("Error in downloading file");
    }
  };

  return (
    <div className="Bulkuploadlocality-container">
      {loading && <Loader />}
      <Toaster />
      <HeaderNavigation value={"Location > Geography Single Upload"} />
      {/* Bulk Upload */}
      <Grid
        container
        sx={{
          backgroundColor: "#eff3fe",
          maxWidth: "100%",
          margin: "10px",
          padding: "10px",
          borderRadius: "5px",
        }}
      >
        <Grid container sx={{ marginBottom: "20px" }}>
          <Subheader heading={"Bulk Upload"} />
        </Grid>

        <Grid
          container
          spacing={2}
          sx={{
            display: "flex",
            alignItems: "end",
          }}
        >
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <Typography>Upload File</Typography>
          </Grid>
        </Grid>
        <Grid container gap={5}>
          <Grid item>
            <input
              ref={fileInputRef}
              type="file"
              accept=".xlsx,.xls,.csv"
              onChange={handleFileChange}
              style={{ padding: "10px" }}
            />
          </Grid>
          <Grid item>
            <CommonButton
              name={"Upload"}
              handleOnClick={handleUpload}
              disabled={!selectedFile}
            />
          </Grid>
          <Grid item sx={{ padding: "1rem" }}>
            <span onClick={handleDownloadTemplate}>
              <Template label={"Download Template"} />
            </span>
          </Grid>
          <Grid item sx={{ padding: "1rem" }}>
            <span onClick={handleDownloadReference}>
              <Template label={"Download Reference Code"} />
            </span>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};

export default BulkUploadLocality;
